var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m4.687 22.5h-4.687v-4.684l13.825-13.825 4.687 4.687zm15.163-15.16-4.688-4.687 2.288-2.288a1.246 1.246 0 0 1 1.762 0l2.925 2.925a1.248 1.248 0 0 1 0 1.763l-2.286 2.287z","fill":"#3d278a","transform":"translate(3.75 3.747)","key":0}),React.createElement("path",{"d":"m0 0h30v30h-30z","fill":"none","key":1})]);
}

Pencil.defaultProps = {"height":"30","viewBox":"0 0 30 30","width":"30"};

module.exports = Pencil;

Pencil.default = Pencil;
